<button class="ion-float-right primary button" [disabled]="disabled" (click)="finalizePatientCall(patientCall)">
  Save
</button>
